'use client';

import * as S from './styles.ts';
import { useState } from 'react';
import TabLabels from './TabLabels';
import TabContent from './TabContent';

type TTabKey = string;

export type TTab = {
  label: string;
  content?: any;
  key?: TTabKey;
  disabled?: boolean;
};

export interface ITabsProps {
  tabs: TTab[];
  defaultSelected?: string | number;
  onTabChange?: (key: TTabKey) => void;
  selected?: string;
}

const TabSlider = ({
  tabs,
  defaultSelected,
  onTabChange,
  selected,
}: ITabsProps) => {
  const [activeTab, setActiveTab] = useState<number | string>(
    defaultSelected || (tabs[0]?.key as any)
  );
  const usedTab = selected || activeTab;

  const onChange = (tab: TTabKey) => {
    if (tabs.find((t) => t.key === tab)?.disabled) {
      return;
    }
    setActiveTab(tab);
    onTabChange && onTabChange(tab);
  };

  return (
    <S.TabsSectionWrapper>
      <S.TabsSectionContainer>
        <TabLabels
          tabs={tabs}
          activeTab={activeTab}
          onChange={(e: any) => onChange(e)}
        />
        {tabs.find((tab) => tab.key === usedTab)?.content && (
          <TabContent>
            {tabs.find((tab) => tab.key === usedTab)?.content}
          </TabContent>
        )}
      </S.TabsSectionContainer>
    </S.TabsSectionWrapper>
  );
};

export default TabSlider;
